import React from 'react'
import { string } from 'prop-types'
import { Box } from 'rebass'
import { Name, JobTitle, Qoute, Email } from './components'
import LazyLoad from 'react-lazyload'
import { lazyload } from '../../utils/style'
import styled from 'styled-components'
import { media } from '../../utils/style'
import buildImageUrl from '../../../lib/media-url-maker'

const Inner = styled(Box)`
  background-color: #ffffff;
  line-height: 1.7;
  box-shadow: 0 18px 18px 0 rgba(66, 76, 94, 0.04),
    0 5px 5px 0 rgba(0, 0, 0, 0.06);
`

const ImageFrame = styled(Box)`
  width: 100%;
  height: 280px;
  z-index: 1;
  display: block;
  color: ${(props) => props.theme.colors.grey_light};
  padding-top: 53.081081081%;
  ${media.MediumScreenUp`
    padding-top: 0;
  `};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-color: ${(props) => props.theme.colors.grey};
  background-image: url(${(props) =>
    buildImageUrl({
      width: 600,
      resource: props.image
    })});

  @media only screen and (-webkit-min-device-pixel-ratio: 1.3),
    only screen and (-o-min-device-pixel-ratio: 1.3/1),
    only screen and (min-resolution: 144dpi),
    only screen and (min-resolution: 1.5dppx) : {
    background-image: url(${(props) =>
      buildImageUrl({
        width: 1200,
        resource: props.image
      })});
  }
`

const Wrapper = styled(Box)`
  padding: 20px 20px 28px 20px;
`

const Headshot = ({ name, email, jobTitle, image, quotation }) => (
  <Box width={[1 / 1, 1 / 2, 1 / 3]}>
    <Inner mx={[10, null, 15]} my={[10, null]}>
      <LazyLoad offset={lazyload.offset} height={280} once>
        <ImageFrame image={image} />
      </LazyLoad>

      <Wrapper px={(10, null, 15)}>
        <Name>{name}</Name>
        <JobTitle>{jobTitle}</JobTitle>
        <Email className="link" href={`mailto:${email}`}>
          {email}
        </Email>
        {quotation && <Qoute>{quotation}</Qoute>}
      </Wrapper>
    </Inner>
  </Box>
)

Headshot.propTypes = {
  name: string,
  email: string,
  jobTitle: string,
  image: string
}

export default Headshot
